import { jsx as _jsx } from "react/jsx-runtime";
import { AlertOutlined, ExperimentOutlined, ToolOutlined } from "@ant-design/icons";
import { Tag } from "antd";
import { useTranslation } from "./i18n.js";
import { config } from "../config/config.js";
function EnvironmentTag({ showOnProduction = false }) {
    const { t } = useTranslation();
    let environmentColor = config.environment.name === "development" ? "green" : config.environment.name === "staging" ? "yellow" : "blue";
    let environmentIcon = config.environment.name === "development" ? /*#__PURE__*/ _jsx(ExperimentOutlined, {}) : config.environment.name === "staging" ? /*#__PURE__*/ _jsx(ToolOutlined, {}) : undefined;
    if (showOnProduction && config.environment.name === "production") {
        environmentColor = "red";
        environmentIcon = /*#__PURE__*/ _jsx(AlertOutlined, {});
    }
    return(// Only non prod will display this tag
    environmentIcon ? /*#__PURE__*/ _jsx(Tag, {
        title: t("Current environment"),
        icon: environmentIcon,
        color: environmentColor,
        children: config.environment.name
    }) : null);
}
export { EnvironmentTag };
